module.exports = __webpack_public_path__ + "static/media/Steve_Bedford.8cc4dac5.jpg";